<template>
  <v-toolbar dense flat class="menu-bar">

    <!-- POČETNA -->
    <v-btn to="/home" text class="menu-link">{{ $t('navmenu.home') }}</v-btn>
    <!--<span class="separator">|</span>-->

    <!-- ORGANIZACIJA  – DROPDOWN -->
    <v-menu offset-y open-on-hover transition="scale-transition" content-class="custom-dropdown">
      <template #activator="{ props }">
        <v-btn v-bind="props" text class="menu-link">
          {{ $t('navmenu.organizacija') }}
          <v-icon right>mdi-menu-down</v-icon>
        </v-btn>
      </template>

      <v-list>

        <v-list-item to="/department" class="dropdown-item" link>
          <v-list-item-title>{{ $t('navmenu.orgJedinice') }}</v-list-item-title>
        </v-list-item>

        <v-list-item to="/workposition" class="dropdown-item" link>
          <v-list-item-title>{{ $t('navmenu.radnePozicije') }}</v-list-item-title>
        </v-list-item>

        <v-list-item to="/user" class="dropdown-item" link>
          <v-list-item-title>{{ $t('navmenu.zaposlenici') }}</v-list-item-title>
        </v-list-item>

        <v-list-item to="/location" class="dropdown-item" link>
          <v-list-item-title>{{ $t('navmenu.lokacije') }}</v-list-item-title>
        </v-list-item>

        <v-list-item to="/room" class="dropdown-item" link>
          <v-list-item-title>{{ $t('navmenu.sobe') }}</v-list-item-title>
        </v-list-item>

        <v-list-item to="/categories" class="dropdown-item" link>
          <v-list-item-title>{{ $t('navmenu.kategorije') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-btn to="/komisije" text class="menu-link">{{ $t('navmenu.komisije') }}</v-btn>


    <!-- SREDSTVA – DROPDOWN -->
    <v-menu offset-y open-on-hover transition="scale-transition" content-class="custom-dropdown">
      <template #activator="{ props }">
        <v-btn v-bind="props" text class="menu-link">
          {{ $t('navmenu.sredstva') }}
          <v-icon right>mdi-menu-down</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item to="/asset" class="dropdown-item" link>
          <v-list-item-title>{{ $t('navmenu.stalnaSredstva') }}</v-list-item-title>
        </v-list-item>

        <v-list-item to="/smallAsset" class="dropdown-item" link>
          <v-list-item-title>{{ $t('navmenu.sitniInventar') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>


    <!-- UGOVORI – DROPDOWN -->
    <v-menu offset-y open-on-hover transition="scale-transition" content-class="custom-dropdown">
      <template #activator="{ props }">
        <v-btn v-bind="props" text class="menu-link">{{ $t('navmenu.ugovori') }}
          <v-icon right>mdi-menu-down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item :to="'/maintenance'" class="dropdown-item" link>
          <v-list-item-title>{{ $t('navmenu.odrzavanja') }}</v-list-item-title>
        </v-list-item>

        <v-list-item :to="'/software'" class="dropdown-item" link>
          <v-list-item-title>{{ $t('navmenu.softveri') }}</v-list-item-title>
        </v-list-item>

      </v-list>
    </v-menu>

    <v-btn to="/popis" text class="menu-link">{{ $t('navmenu.popis') }}</v-btn>
    <v-btn to="/reports" text class="menu-link">{{ $t('navmenu.izvjestaji') }}</v-btn>

  </v-toolbar>
</template>

<script>
export default {
  name: "InventoryNavNew",
};
</script>

<style scoped>
.menu-bar :deep(.v-toolbar__content) {
  flex-wrap: nowrap !important;
  overflow: visible;
}

.v-toolbar {
  width: 70%;
}

.menu-bar {
  background-color: #142854 !important;
  /* teget */
  padding-left: 0 !important;
  margin-top: -8px;
  width: 100%;
}

.separator {
  color: white;
  margin: 0 12px;
  font-weight: 300;
  font-size: 30px;
  margin-top: -6px;
}

.p-4 {
  padding-left: 0 !important;
}

/* Dropdown stil (opciono) */
.v-list-item-title {
  font-size: 14px;
}

.nav-item {
  cursor: pointer;
  align-items: center;
  color: black !important;
  text-transform: uppercase;
  text-decoration: none;
}

.menu-link {
  color: rgba(255, 255, 255, 0.9) !important;
  font-size: 13.5px;
  font-weight: 600;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  transition: all 0.2s ease;
  margin-right: 16px;
}

.menu-link:hover {
  color: #ffffff !important;
}

.custom-dropdown {
  border-radius: 10px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  padding: 0 !important;
  border: 1px solid #eef1f5;
}

/* Dropdown items */
.dropdown-item {
  min-height: 42px;
  padding: 8px 20px !important;
  font-size: 13px;
  font-weight: 500;
  color: #1e293b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: background-color 0.2s ease, color 0.2s ease;
}

/* Hover effect */
.dropdown-item:hover {
  background-color: #f4f8ff;
  color: #1357A2;
}

.dropdown-item:first-child {
  margin-top: -6px;
}

.dropdown-item:last-child {
  margin-bottom: -6px;
}

/* Active router link */
.dropdown-item.router-link-active {
  background-color: #e8f0ff;
  color: #1357A2;
  font-weight: 600;
}

/* Optional subtle separator between items */
.custom-dropdown .v-list-item+.v-list-item {
  border-top: 1px solid #D0D1D3;
}

.v-list-item-title {
  text-transform: uppercase !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  margin-top: 2px;
}
</style>
